import React from "react";

import { DonationsProps } from "./index";

interface DonationModalProps {
    handleClose: () => void;
    selectedDonation?: DonationsProps;
}

const DonationModal:React.FC<DonationModalProps> = (props) => {
    const { selectedDonation, handleClose } = props;
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4 overflow-y-auto">
        <div className="bg-white rounded-2xl shadow-2xl w-full max-w-5xl min-h-[50vh] max-h-[95vh] overflow-hidden flex flex-col">
            <div className="bg-gradient-to-r bg-green-800 text-white p-6 flex justify-between items-center">
            <div>
                <h2 className="text-3xl font-bold">{selectedDonation ? 'Edit Donations Campaign' : 'Donations Campaign Creation'}</h2>
                <p className="text-sm opacity-80">
                    Every great change starts with a single step.
                    Set up your donation campaign, share your mission, and inspire people to contribute
                    towards a better future.
                    Make giving simple, meaningful, and impactful!
                </p>
            </div>
            </div>
            <form className='p-6 flex-1 overflow-y-auto'>
                <div className="flex flex-col md:flex-row items-center gap-4 mb-4">
                  <div className="flex-1">
                    <label className="block text-gray-700 mb-2">Campaign Name</label>
                    <input type="text" className="w-full p-2 border border-gray-300 rounded" value={selectedDonation?.name} />
                  </div>
                  <div className="flex-1">
                    <label className="block text-gray-700 mb-2">Target Amount</label>
                    <input type="number" className="w-full p-2 border border-gray-300 rounded" defaultValue={selectedDonation?.targetAmount} />
                  </div>
                </div>
                  <div className="mb-4">
                    <label className="block text-gray-700 mb-2">Select Donation Type</label>
                    <select className="w-full p-2 border border-gray-300 rounded" defaultValue={selectedDonation?.status}>
                      <option value="oneTime">One Time</option>
                      <option value="recurring">Recurring</option>
                    </select>
                  </div>
                  <div className="mb-4">
                    <label className="block text-gray-700 mb-2">Campaign Description</label>
                    <textarea className="w-full p-2 border border-gray-300 rounded" placeholder="Provide Campaign Description" >{selectedDonation?.description}</textarea>
                  </div>
                  <div className="mb-4">
                    <label className="block text-gray-700 mb-2">Campaign Banner</label>
                    <input type="file" className="w-full p-2 border border-gray-300 rounded" placeholder="Enter telephone number" />
                  </div>
                  <div className="flex justify-end gap-2">
                    <button type="button" onClick={handleClose} className="px-4 py-2 text-gray-700 border rounded hover:bg-gray-100">Cancel</button>
                    <button type="submit" className="px-4 py-2 bg-green-700 text-white rounded hover:bg-green-800">Save Changes</button>
                  </div>
                </form>
            </div>
        </div>
    );
}

export default DonationModal;